import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import ItemList from 'flarum/common/utils/ItemList';
import SubscriptionCard from './SubscriptionCard';
/**
 * The `DiscussionsUserPage` component shows a discussion list inside of a user
 * page.
 */
export default class UserSubscriptionsPage extends UserPage {
  loading = false;
  subscriptions = [];
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = true;
    this.loadUser(m.route.param('username'));
    this.loadSubscriptions();
  }
  show(user) {
    super.show(user);
  }
  content() {
    return m("div", {
      className: "AccessPortal SubscriptionsUserPage"
    }, this.loading ? m(LoadingIndicator, null) : this.items().toArray());
  }
  items() {
    const items = new ItemList();
    this.subscriptions.forEach(subscription => {
      items.add(subscription.id(), m(SubscriptionCard, {
        subscription: subscription
      }));
    });
    if (!this.loading && this.subscriptions.length === 0) {
      items.add('empty', m(SubscriptionCard, {
        subscription: null
      }));
    }
    return items;
  }
  loadSubscriptions() {
    app.store.find('floxum-subscriptions', {
      include: 'relatesTo'
    }).then(subscriptions => {
      this.subscriptions = subscriptions;
      this.loading = false;
      m.redraw();
    });
  }
}
flarum.reg.add('floxum-payments', 'forum/Pages/UserSubscriptionsPage', UserSubscriptionsPage);